import { Link } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Roster", to: "/roster" },
  { label: "Events", to: "/events" },
  { label: "Shop", to: "/shop" },
];

const socialLinks = [
  { icon: "ri-instagram-line", href: "#", label: "Instagram" },
  { icon: "ri-facebook-circle-line", href: "#", label: "Facebook" },
  { icon: "ri-twitter-x-line", href: "#", label: "Twitter / X" },
  { icon: "ri-youtube-line", href: "#", label: "YouTube" },
];

const galleryImages = [
  { src: "https://framerusercontent.com/images/ewoAtgP7LBzHDhNZvOwF5JLCI.png", alt: "PWA gallery 1" },
  { src: "https://framerusercontent.com/images/D5udWWIi0vcUsKlLAVYNsu2zIk.png", alt: "PWA gallery 2" },
  { src: "https://framerusercontent.com/images/Zwaol9zKEK4VdBsha8QV1SrzTiw.png", alt: "PWA gallery 3" },
  { src: "https://framerusercontent.com/images/t56Efpc7KyUc33UXBmCP9qcgV8.png", alt: "PWA gallery 4" },
];

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Orange accent line at top */}
      <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-orange-500 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">

          {/* Brand + Contact */}
          <div className="lg:w-72 flex-shrink-0">
            <Link to="/" className="inline-block mb-4">
              <img
                src="https://framerusercontent.com/images/kSUcoz9EYB2x3E5QYqyi2hBJxzQ.png"
                alt="Pacific Wrestling Alliance"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              USA&apos;s Premier Wrestling Alliance — bringing the hardest-hitting action to fans across the country.
            </p>

            {/* Social icons */}
            <div className="flex gap-3 mb-8">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 text-gray-400 hover:text-orange-500 hover:border-orange-300 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>

            <p className="font-condensed font-bold text-gray-900 text-xs uppercase tracking-widest mb-3">Contact</p>
            <div className="flex flex-col gap-1.5">
              <a
                href="mailto:pacificwrestlingalliance@gmail.com"
                className="text-gray-500 text-xs hover:text-orange-500 transition-colors cursor-pointer"
              >
                pacificwrestlingalliance@gmail.com
              </a>
              <a
                href="tel:5628897086"
                className="text-gray-500 text-xs hover:text-orange-500 transition-colors cursor-pointer"
              >
                562-889-7086
              </a>
            </div>
          </div>

          {/* Vertical divider (desktop) */}
          <div className="hidden lg:block w-px bg-gray-200 self-stretch" />

          {/* Nav Links */}
          <div className="flex-shrink-0">
            <p className="font-condensed font-bold text-gray-900 text-xs uppercase tracking-widest mb-5">Navigation</p>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="group flex items-center gap-2 text-gray-500 text-sm hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-3 h-px bg-orange-400 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Vertical divider (desktop) */}
          <div className="hidden lg:block w-px bg-gray-200 self-stretch" />

          {/* Gallery */}
          <div className="flex-1">
            <p className="font-condensed font-bold text-gray-900 text-xs uppercase tracking-widest mb-5">Gallery</p>
            <div className="grid grid-cols-4 gap-2">
              {galleryImages.map((img, i) => (
                <div
                  key={i}
                  className="aspect-square overflow-hidden bg-gray-200 relative group cursor-pointer rounded-sm"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <i className="ri-instagram-line text-white text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  {/* orange bottom bar on hover */}
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
                </div>
              ))}
            </div>
            <p className="text-gray-400 text-xs mt-3">Follow us on Instagram for live updates &amp; behind-the-scenes content.</p>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">
            &copy; 2025 Pacific Wrestling Alliance. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs">
            Powered by{" "}
            <a
              href="https://kalamazoowebsitedesign.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-gray-600 hover:text-orange-500 transition-colors duration-200 cursor-pointer underline underline-offset-2"
            >
              Kalamazoo Website Design
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
